import { RootState } from "@app/redux/root-reducer";

export const selectAllProductDataState = (store: RootState) =>
  store.allProductReducer.product;
export const selectAllCarsDataState = (store: RootState) =>
  store.allProductReducer.allCars;
export const selectAllBrandsDataState = (store: RootState) =>
  store.allProductReducer.brands;
export const selectAllCategoryDataState = (store: RootState) =>
  store.allProductReducer.category;
export const selectAllLocationDataState = (store: RootState) =>
  store.allProductReducer.findLocation;
export const selectFindByProductIdState = (store: RootState) =>
  store.allProductReducer.productFindById;
export const selectAddProductState = (store: RootState) =>
  store.allProductReducer.addProduct;
export const selectUpdateProductState = (store: RootState) =>
  store.allProductReducer.updateProductIdBy;
export const selectDeleteProductState = (store: RootState) =>
  store.allProductReducer.deleteProductById;
